import { Component } from '@angular/core';
import { AbstractModalWithResult } from 'src/app/shared/components/abstract-modal-with-result';

/**
 * Used in mobile mode (in which there is only an "enveloppe" button to send the message,
 * as opposed to the "Send" and "Send and..." buttons in desktop mode)
 * to let the user decide whether they want to trigger the survey
 */
@Component({
  selector: 'app-send-and-trigger-survey',
  templateUrl: './send-and-trigger-survey.component.html',
  styleUrls: ['./send-and-trigger-survey.component.scss'],
})
export class SendAndTriggerSurveyComponent extends AbstractModalWithResult<boolean> {
  static modalId = 'SendAndTriggerSurveyComponent';

  isTriggerSurvey: boolean;

  getModalId() {
    return SendAndTriggerSurveyComponent.modalId;
  }
}
